// Simple Testimonial Controller
class TestimonialController {
    constructor() {
        this.autoSlideInterval = null;
        this.currentIndex = 0;
        this.isUserInteracting = false;
        this.container = null;
        this.wrappers = [];
        this.autoSlideDelay = 3000;
        this.pauseDelay = 5000;
    }

    init() {
        this.cacheElements();
        this.setupDesktopInteractions();
        this.setupMobileInteractions();
        this.startAutoSlide();

        // Handle resize
        window.addEventListener('resize', this.debounce(() => {
            this.stopAutoSlide();
            this.cacheElements();
            this.setupDesktopInteractions();
            this.setupMobileInteractions();
            setTimeout(() => this.startAutoSlide(), 500);
        }, 250));
    }

    cacheElements() {
        this.container = document.querySelector('.testimonials-container');
        this.wrappers = [...document.querySelectorAll('.testimonials-wrapper')];
        this.section = document.querySelector('.testimonial-section');
    }



    // Desktop interactions
    setupDesktopInteractions() {
        if (window.innerWidth < 1024) return;

        // Find current active slide
        const activeIndex = this.wrappers.findIndex(w => w.classList.contains('active'));
        if (activeIndex >= 0) this.currentIndex = activeIndex;

        // Wrapper clicks and hovers
        this.wrappers.forEach((wrapper, index) => {
            wrapper.onclick = () => this.goToSlide(index, true);
            wrapper.onmouseenter = () => this.goToSlide(index, false);
            wrapper.onmouseleave = () => this.resumeAutoSlide();
        });

        // Navigation buttons
        document.querySelectorAll('.testimonial-section .left-navigation').forEach(btn => {
            btn.onclick = (e) => {
                e.stopPropagation();
                this.goToSlide(this.currentIndex - 1, true);
            };
        });

        document.querySelectorAll('.testimonial-section .right-navigation').forEach(btn => {
            btn.onclick = (e) => {
                e.stopPropagation();
                this.goToSlide(this.currentIndex + 1, true);
            };
        });
    }

    // Mobile interactions
    setupMobileInteractions() {
        if (window.innerWidth >= 1024 || !this.container) return;

        let isScrolling = false;
        let scrollTimeout;

        const handleInteractionStart = () => {
            this.isUserInteracting = true;
            this.stopAutoSlide();
            isScrolling = true;
        };

        const handleInteractionEnd = () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                isScrolling = false;
                this.syncWithScroll();
                setTimeout(() => {
                    this.isUserInteracting = false;
                    this.startAutoSlide();
                }, 1000);
            }, 150);
        };

        this.container.addEventListener('touchstart', handleInteractionStart, { passive: true });
        this.container.addEventListener('touchend', handleInteractionEnd, { passive: true });
        this.container.addEventListener('scroll', () => {
            if (!isScrolling) handleInteractionStart();
            handleInteractionEnd();
        }, { passive: true });
    }

    // Sync current index with scroll position
    syncWithScroll() {
        if (window.innerWidth >= 1024 || !this.container || this.wrappers.length === 0) return;

        const scrollLeft = this.container.scrollLeft;
        const wrapperWidth = this.wrappers[0].offsetWidth;
        const gap = 10; // Adjust based on your CSS
        const slideWidth = wrapperWidth + gap;

        this.currentIndex = Math.round(scrollLeft / slideWidth) % this.wrappers.length;
    }

    // Go to specific slide
    goToSlide(index, pauseAfter = false) {
        // Normalize index
        this.currentIndex = ((index % this.wrappers.length) + this.wrappers.length) % this.wrappers.length;

        if (window.innerWidth >= 1024) {
            // Desktop: Update active classes
            this.wrappers.forEach(w => w.classList.remove('active'));
            this.wrappers[this.currentIndex]?.classList.add('active');
        } else {
            // Mobile: Scroll to position
            if (this.container && this.wrappers.length > 0) {
                const wrapperWidth = this.wrappers[0].offsetWidth;
                const gap = 10;
                const slideWidth = wrapperWidth + gap;
                const scrollPosition = this.currentIndex * slideWidth;

                this.container.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                });
            }
        }

        if (pauseAfter) {
            this.stopAutoSlide();
            setTimeout(() => this.startAutoSlide(), this.pauseDelay);
        }
    }

    // Auto slide functionality
    startAutoSlide() {
        if (this.isUserInteracting) return;

        this.stopAutoSlide();
        this.autoSlideInterval = setInterval(() => {
            if (!this.isUserInteracting) {
                this.goToSlide(this.currentIndex + 1);
            }
        }, this.autoSlideDelay);
    }

    stopAutoSlide() {
        if (this.autoSlideInterval) {
            clearInterval(this.autoSlideInterval);
            this.autoSlideInterval = null;
        }
    }

    resumeAutoSlide() {
        if (!this.isUserInteracting) {
            this.startAutoSlide();
        }
    }

    // Simple debounce utility
    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
}

// Initialize
const testimonials = new TestimonialController();

// Wait for page load
const initTestimonials = () => {
    testimonials.init();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonials);
} else {
    initTestimonials();
}

window.addEventListener('load', initTestimonials);
window.addEventListener('beforeunload', () => testimonials.stopAutoSlide());